import GenericAddresses from '@/components/Addresses/GenericAddresses';

export default function CustomerAddresses() {
  return <GenericAddresses path="customers" />;
}
